/* eslint-disable filenames/match-regex */
const CCIconStyle = {
  height: 24,
  lineHeight: '14px',
  marginRight: '8px',
  position: 'relative',
  top: '-2px',
  verticalAlign: 'middle',
  width: 30,
};

export default CCIconStyle;
